export const dateTimeLocale = "pl-PL";

export const weekdayLocale = "en-GB";

export const displayTimeZone = "Europe/Warsaw";

export const momentDatePattern = "DD.MM.YYYY";

export const datePickerDatePattern = "dd.MM.yyyy";

export const momentDateTimePattern = "DD.MM.YY HH:mm";

const hasTimeZoneDesignator = (dateString: string) =>
  dateString.endsWith("Z") || /[+-]\d{2}:?\d{2}$/.test(dateString);

export const parseUtcDate = (dateString: string) =>
  new Date(hasTimeZoneDesignator(dateString) ? dateString : `${dateString}Z`);
